import { useState } from "react";
import { motion } from "framer-motion";

const transition = {
  duration: 0.8,
  ease: [0.6, -0.5, 0.01, 0.9],
};

const variants = {
  initial: {
    height: 0,
    borderBottomLeftRadius: ["50%", window.innerHeight, 0],
    borderBottomRightRadius: ["50%", window.innerHeight, 0],
  },
  animate: {
    height: [0, window.innerHeight, 0],
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    bottom: [0, 0, window.innerHeight],
  },
  exit: {
    height: [0, window.innerHeight, 0],
    borderBottomLeftRadius: [window.innerHeight, 0, "50%"],
    borderBottomRightRadius: [window.innerHeight, 0, "50%"],
    bottom: [null, 0, 0],
  },
};

const Panel = () => {
  const [panelComplete, setPanelComplete] = useState(false);

  return (
    <motion.div
      className="panel-background"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      transition={{ ...transition, duration: 1.5, times: [0, 0.5, 1] }}
      onAnimationComplete={() => setPanelComplete(!panelComplete)}
    ></motion.div>
  );
};

export default Panel;
